import React, { useContext } from 'react'
import ColorContext from '../../context/ColorContext'

const Certified = ({ style }) => {
	const { color } = useContext(ColorContext)
	return (
		<svg
			id="svgCertified"
			className="svgInline"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="-185 356 240 81"
			style={style}
		>
		<linearGradient id="certifiedGradient" gradientUnits="userSpaceOnUse" x1="-369.2292" y1="788.0974" x2="-368.2292" y2="788.0974" gradientTransform="matrix(240 0 0 -80.6349 88430 63944.4766)">
			<stop  offset="0" style={{ stopColor: color.bravo }} />
			<stop  offset="1" style={{ stopColor: color.alpha }} />
		</linearGradient>
		<g id="certifiedText" fill="url(#certifiedGradient)">
			<path d="M-51.8,378.3c1.4,0,4.4-1.8,4.4-4.7c0-2.7-1.3-3.4-2.7-3.4c-2.4,0-4.2,2.2-4.2,4
				C-54.3,376-53.6,378.3-51.8,378.3z"/>
			<path d="M-83,393.9c0-2.8-1.8-4.2-4.2-4.2
				c-2.9,0-7,3.6-11.5,8.3c1-2.6,1.9-5,1.9-5.8c0-1.2-1-2-2.4-2c-1.8,0-2.5,1.7-3.4,4.6c-0.3,0.9-0.7,2.3-1.4,4
				c-0.4,0.5-0.9,1-1.3,1.6c-4,4.9-11.4,13.5-20.7,13.5c-2.1,0-3.1-2.1-3.1-3c0-0.8,0.4-1.6,1.9-1.9c7.3-1.7,16.6-8.3,16.6-14.1
				c0-2.5-2.6-4.2-4.9-4.2c-4.9,0-11.1,3.6-15.5,10.8c-7.4,9.5-23.6,26.1-38.7,26.1c-5.6,0-9.2-4.9-9.2-11.3
				c0-24.9,30.8-54.5,46.4-54.5c2.3,0,3.4,1.3,3.4,3.2c0,6.7-6.4,15.3-11.3,16.4c-3.4,0.8-4,2.7-4,4c0,1.6,1,2.4,3.3,2.4
				c5.9,0,17.9-13.3,17.9-22.9c0-5.7-3.8-8.1-9.1-8.1c-19.7,0-52.9,31-52.9,60c0,10.5,5.9,16.3,15.1,16.3c12.1,0,25.4-11.1,35.3-21.3
				c0.5,4.2,3.3,6.6,6.7,6.6c7.9,0,14.5-4,19.5-8.6c-0.9,2.6-1.6,4.8-1.6,5.6c0,1.6,1.5,2.8,2.9,2.8c0.7,0,1.7-2.1,2.5-4.4
				c1-2.5,2.2-4.9,3.2-6.4c3.6-5.3,10.7-12.2,12.2-12.2c0.6,0,0.7,0.2,0.7,0.6c0,0.6-0.8,2-0.8,3c0,1.3,1,2.2,2.2,2.2
				C-83.9,400.9-83,397.7-83,393.9z M-117,395.5c0.7,0,0.9,0.5,0.9,1.1c0,1.9-7.5,7.4-11.5,8.2C-125.5,401.5-119.6,395.5-117,395.5z"
				/>
			<path d="M-68.9,386.6c3-1,6.5-1.9,8.7-1.9
				c1.3,0,2.3,0.5,2.3,0.9c0,0.6-0.2,1-0.2,1.6c0,0.7,0.3,1.3,1.7,1.3c1.7,0,3.4-2.6,3.4-4.8c0-2.6-2-3.7-6.1-3.7
				c-2.2,0-4.4,0.5-6.3,1c3.1-5.6,3.8-7.3,5.3-8.4c2.2-1.8,2.7-2.7,2.7-4.1c0-1.7-0.8-2.6-2.8-2.6c-1.7,0-3,1.3-4.9,4
				c-2,2.7-3.8,6.4-7.6,13.2c-1,0.3-2.1,0.5-3,0.5c-1.3,0-2.2-0.9-3.3-0.9c-2,0-3.1,1.5-3.1,3.2c0,1.8,1.2,2.6,6.5,2.6
				c-5,9.9-10.4,22.7-10.4,28.6c0,3.1,1.1,4.7,3.1,4.7c1.7,0,2.7-1.6,2.7-2.6c0-0.7-0.8-1.8-0.8-2.8
				C-80.9,410.7-75.1,397.7-68.9,386.6z"/>
			<path d="M50,356c-4,0-10,4.5-14.6,14.4
				c-4.3,9.3-6.6,16.6-7.8,21.9c-1-0.6-2.8-1.8-5.8-1.8c-4.6,0-10.8,5.4-14.6,11.5c-4.2,5-11,11.8-19.2,11.8c-2.1,0-3.1-2.1-3.1-3
				c0-0.8,0.4-1.6,1.9-1.9c7.3-1.7,16.6-8.3,16.6-14.1c0-2.5-2.5-4.2-4.9-4.2c-4.8,0-10.9,3.5-15.2,10.4c-3.9,5.1-11.4,12.1-14.2,12.1
				c-1,0-1.5-1-1.5-1.8c0-2.2,3.1-9.9,6.3-15.2c0.7-1,1.4-1.8,1.4-3.4c0-1.5-1.2-2.3-2.8-2.3c-1.1,0-1.9,0.9-2.8,2h-10.4
				c3.9-8.6,6.5-13.6,9.4-18.4c5-8.3,10.4-12.3,12.6-12.3c0.7,0,1,0.3,1,1c0,1.1,0.8,2,2.1,2c1.6,0,3.2-1.7,3.2-4.2
				c0-2.1-2.3-3.9-5.9-3.9c-5.2,0-13.4,7.1-18.6,16.3c-4.7,8.4-6.6,13-9.5,19.5h-2.5c-2,0-3,1.1-3,3.1c0,1.5,0.8,1.9,3.2,1.9
				c-0.2,0.6-0.5,1.3-0.8,1.9c-0.3,0.3-0.5,0.7-0.8,1c-3.8,5.1-11.7,12.7-14.7,12.7c-1,0-1.5-1-1.5-1.8c0-2.2,3.1-9.9,6.3-15.2
				c0.7-1,1.4-1.8,1.4-3.4c0-1.5-1.2-2.3-2.8-2.3c-1.5,0-2.6,1.8-4,4c-0.9,1.7-6.5,12.6-6.5,17.5c0,3.9,2.5,5.9,4.9,5.9
				c3.8,0,9.4-4.1,14.3-8.8c-2.6,8.3-4.7,17.3-4.7,22.9c0,3.6,1.5,4.7,3.2,4.7c1.8,0,2.7-1.8,2.7-2.9c0-1.6-0.8-2.4-0.8-3.5
				c0-7.6,4.9-22.2,9.7-33.3c3.3-0.3,6.7-0.6,10.1-0.7c-1.9,3.8-5.4,11.6-5.4,15.5c0,3.9,2.5,5.9,4.9,5.9c3.3,0,8.1-3.2,12.5-7.1
				c0.1,4.7,3.2,7.5,6.7,7.5c6.9,0,12.8-3.1,17.5-6.9c0,0.2,0,0.4,0,0.6c0,4.8,3.6,6.6,5.9,6.6c3.5,0,10.1-3.7,14.9-9
				c0,5.5,1,12.3,6.3,12.3c2.4,0,4.1-1.6,4.1-2.7c0-1-1.1-1.2-2.2-1.5c-2.4-0.6-2.6-6.2-2.6-8.6c0-2.9,0.4-5.6,1.4-7.6
				c0.3-1,1.9-2.6,3.5-4.5c3.1-3.6,8.3-9.6,12.6-16.5c5.6-9,7.5-14.8,7.5-18.9C55,358.2,53.2,356,50,356z M-3,395.5
				c0.7,0,0.9,0.5,0.9,1.1c0,1.9-7.5,7.4-11.5,8.2C-11.5,401.5-5.6,395.5-3,395.5z M11.2,413.2c-1,0-1.9-0.8-1.9-2.2
				c0-4,7.6-14.5,12.5-14.9c0.9,0,1.8,0.5,1.9,1.3c0.1,1.2,1,1.7,1.7,1.9C24.7,402.6,14.6,413.2,11.2,413.2z M43.7,377.2
				C40,384,35.3,389.5,33.2,392c0,0,3.2-11.6,6.6-18.5c4.5-9,7.8-12.2,8.7-12.2c1,0,1.3,0.3,1.3,1.2C49.9,365.5,48.4,368.8,43.7,377.2
				z"/>
			<path d="M-16.1,370.3c-2.4,0-4.2,2.2-4.2,4
				c0,1.7,0.7,4,2.4,4c1.4,0,4.4-1.8,4.4-4.7C-13.5,371-14.8,370.3-16.1,370.3z"/>
		</g>
	</svg>
	)
}

export default Certified